import { useContext, forwardRef } from "react";
import { formInlineContext } from "../FormInline";
import { twMerge } from "tailwind-merge";

interface FormSelectProps extends React.ComponentPropsWithoutRef<"select"> {
  formSelectSize?: "sm" | "lg";
}

const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(
  ({ formSelectSize, className, ...props }, ref) => {
    const formInline = useContext(formInlineContext);

    return (
      <select
        ref={ref} // Make sure to forward the ref
        {...props}
        className={
          "bg-[length:20px_auto] " +
          twMerge([
            "disabled:bg-slate-100 disabled:cursor-not-allowed disabled:dark:bg-darkmode-800/50",
            "[&[readonly]]:bg-slate-100 [&[readonly]]:cursor-not-allowed [&[readonly]]:dark:bg-darkmode-800/50",
            "bg-chevron-black transition duration-200 ease-in-out w-full text-sm border-slate-300/60 shadow-sm rounded-md py-2 px-3 pr-8 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40 dark:bg-darkmode-800 dark:border-transparent dark:focus:ring-slate-700 dark:focus:ring-opacity-50",
            formSelectSize == "sm" && "text-xs py-1.5 pl-2 pr-8",
            formSelectSize == "lg" && "text-lg py-1.5 pl-4 pr-8",
            formInline && "flex-1",
            className,
          ])
        }
      >
        {props.children}
      </select>
    );
  },
);

FormSelect.displayName = "FormSelect"; // Required for forwardRef components

export default FormSelect;
